import React from 'react';
import { Heading } from 'seduo-ui';
import classNames from 'classnames';
import HighlightText from './HighlightText';
const Item = ({ isActive, children, href, title, subTitle, rightColumn, highlightValue, onMouseDown }) => (<li className={classNames('search-list__item', {
        'search-list__item--active': isActive,
    })}>
        <a href={href} onMouseDown={onMouseDown} className="search-list__link">
            <span className="search-list__item-column">
                <span className="search-list__image">{children}</span>
                <span>
                    <Heading level={3} className="search-list__title">
                        <HighlightText highlightValue={highlightValue} textToHighlight={title}/>
                    </Heading>
                    {subTitle && <span className="search-list__subtitle text-truncate">{subTitle}</span>}
                </span>
            </span>
            <span className="search-list__item-column search-list__item-column--right">{rightColumn}</span>
        </a>
    </li>);
export default Item;
